import React from "react"
import { Flex } from "@chakra-ui/react"
import { useWishlistToggle } from "@app/hooks/useWishlistToggle"
import WishlistIcon from "@app/components/Wishlist/WishlistIcon"
import Icon from "../Icon"

type Props = {
  product: any
  wishlistId?: string
  isWishlistSharedPage?: boolean
  handleAdd?: () => void
  variant?: "normal" | "cart"
  /** GA4 `location` param for wishlist events: card / quick_add / pdp / cart */
  location?: string
}

const ProductCardWishlist: React.FC<Props> = ({
  product,
  wishlistId,
  isWishlistSharedPage,
  handleAdd,
  variant = "normal",
  location = "card",
}) => {
  // Shape normalisation (incl. cart merchandise) and add/remove logic are shared via the hook + provider.
  const { fetched, available, inWishlist, loading, toggle } = useWishlistToggle(product, {
    wishlistId,
    isWishlistSharedPage,
    onAdd: handleAdd,
    location,
  })

  return fetched && available ? (
    <Flex
      as="button"
      p={variant === "cart" ? { base: "8px", sm: "8px" } : 0}
      boxSize={variant === "cart" ? undefined : "40px"}
      alignItems={variant === "cart" ? undefined : "center"}
      justifyContent={variant === "cart" ? undefined : "center"}
      cursor="pointer"
      onClick={toggle}
      disabled={loading}
      aria-label={inWishlist ? "Remove from wishlist" : "Add to wishlist"}
    >
      {!!wishlistId && inWishlist && !isWishlistSharedPage ? (
        <Icon name="closeSmall" w={7} aria-label="Remove from wishlist" />
      ) : (
        <WishlistIcon
          filled={inWishlist}
          transition={loading ? "all 1s ease" : "none"}
          opacity={!loading && inWishlist ? 1 : 0.3}
          p={0}
          width="21px"
          height="20px"
          sx={{
            transition: "all 0.3s ease",
            "@media (hover: hover) and (pointer: fine)": {
              "&:hover": !loading
                ? {
                    opacity: 1,
                    color: "preset.red",
                    fill: "#FCA09C",
                  }
                : {},
            },
          }}
        />
      )}
    </Flex>
  ) : null
}

export default React.memo(ProductCardWishlist)
